import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "cadastral-units-map-field",
  style: {"display":"block","width":"100%","height":"100%"}
}
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = {
  class: "map-container",
  style: {"width":"100%","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CadastralUnitsMap = _resolveComponent("CadastralUnitsMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "hidden",
      name: _ctx.name,
      value: _ctx.selectedIdsString,
      ref: "hiddenField"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CadastralUnitsMap, {
        center: _ctx.center,
        loadPointsUrl: _ctx.loadPointsUrl,
        initialSelectedIds: _ctx.value,
        useGeolocation: _ctx.useGeolocation,
        onSelectionChanged: _ctx.handleSelectionChange
      }, null, 8, ["center", "loadPointsUrl", "initialSelectedIds", "useGeolocation", "onSelectionChanged"])
    ])
  ]))
}